import {observable, computed, action} from 'mobx';
import {
    SHOP_CLOSED_WITH_ORDERS_FLAG,
    LIVE_ORDER_STREAM_STYLE,
    SAVED_STYLES_COLLECTION
} from '../constants';
const HUNDRED_PERCENT = 100

export default class StyleStore {

    @observable styleName = 'default_light';
    @observable liveStreamOrderStyle = LIVE_ORDER_STREAM_STYLE.horizontal.withoutAlert

    constructor(configStore) {
        this.configStore = configStore
    }

    @action
    updateStyleName(newStyleName) {
        if (typeof newStyleName !== 'undefined' && SAVED_STYLES_COLLECTION[newStyleName]) {
            this.styleName = newStyleName
        }
    }

    @computed
    get currentStylesDict() {
        return SAVED_STYLES_COLLECTION[this.styleName];
    }

    get currentStyleName() {
        return this.styleName;
    }

    @computed
    get currentLiveStreamOrderStyle(){
        const {isVertical, isAlertShown, displayAlert, isShopOpen, nextShopStateChange} = this.configStore
        const dimension = isVertical ? 'vertical' : 'horizontal'
        const styleByDimension = LIVE_ORDER_STREAM_STYLE[dimension]
        const customStyle = !isAlertShown ? LIVE_ORDER_STREAM_STYLE[dimension].withoutAlert : this.getCustomStyleWithAlert(isShopOpen, styleByDimension, displayAlert, !!nextShopStateChange)
        let currentStyle = {...styleByDimension.common,  ...customStyle}
        currentStyle['panelHeaderHeight'] = `${this.calculatePanelHeaderHeight(currentStyle)}%`
        return currentStyle
    }

    calculatePanelHeaderHeight(currentStyle) {
        const {widgetHeaderHeight, panelHeaderSplitLineHeight, alertHeight, widgetHeaderMarginTop} = currentStyle
        const heightsArray = [widgetHeaderHeight, panelHeaderSplitLineHeight, alertHeight, widgetHeaderMarginTop]
        const sumHeights = heightsArray.reduce((sum, height) => sum+=Number(height.slice(0, height.length-1)), 0)
        return HUNDRED_PERCENT - sumHeights
    }

    getCustomStyleWithAlert(isShopOpen, styleByDimension, alertFlag, isWithOpenHours) {
        const relevantStyle = styleByDimension.withAlert
        if (!isShopOpen) {
            return relevantStyle.default
        }
        if (alertFlag === SHOP_CLOSED_WITH_ORDERS_FLAG && isWithOpenHours) {
            return {...relevantStyle.default, ...relevantStyle.shopClosedWithOpenHours}
        }
        return relevantStyle.default
    }
}



// WEBPACK FOOTER //
// ./src/stores/StyleStore.js